import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Table} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';

import moment from "moment"


class AltiomTile extends Component{

  defined(v){
    if(v===undefined)
      return ""
      return v
  }
  buttonPress(e){

  let data=e.currentTarget.dataset
  console.log(data)

  API.post("AltiomData", "/altiom/"+data.altid,{body:data}).then(response => {
    console.log(response)
    }).catch(error => {
        console.log(error.response)
    });

  }

  online(data){
    console.log(data)
    if(data===1)
      return (<span className="green">Online</span>)
    if(data===0)
      return (<span className="red" >Offline</span>)

  }
  render(){

    let d=this.props

    return (  <ListGroupItem
          key={d.altid}
          header={this.defined(d.UNIT)+" > "+this.defined(d.ROOM)}
        >
        <p>
        {"("+d.altid+")::V"+this.defined(d.VERSION)}
        </p>
        <p>
        {this.defined(d.IP)}
        <i> site id:({d.branch})</i>
        </p>

        <ButtonGroup bsSize="small" className="pull-right">
          <Button onClick={this.buttonPress} data-cmd="macro" data-id="beep" data-type="run" data-altid={d.altid}>Beep</Button>
          <Button onClick={this.buttonPress} data-cmd="REBOOT" data-altid={d.altid}>Reboot</Button>
          {/*<Button onClick={this.buttonPress} data-cmd="update" data-altid={d.altid}>Update</Button>*/}
          {/*<Button onClick={this.buttonPress} data-cmd="PIC" data-type="bootloader" data-altid={d.altid}>Prog PIC</Button>*/}
          <Button href={"/a/"+d.altid}>View</Button>
        </ButtonGroup>
        {this.online(d.online)}

        <b> Last Message:</b><Moment fromNow>{d.last_seen}</Moment>)
  </ListGroupItem>)

  }
}




export default class Home extends Component {

  constructor(props) {
      super(props);

      this.state = {
        isLoading: true,
        altioms: [],
        data:[{"_source":{}}],
        datafiltered:[],
        filterStr:"",
        branchdata:{},
        sortmode:"location",
        sortmodereverse:false
      };
    }


  async componentDidMount() {
      if (!this.props.isAuthenticated) {
        return;
      }

      try {
        let branchdata=await this.getAdmin({admin:true,type:"branches",cmd:"listbranches"})
        let branchkeys={}
        for(let i=0;i<branchdata.length;i++){
          branchkeys[branchdata[i].userId]=branchdata[i]
        }
        console.log(branchkeys)

        this.setState({branchdata:branchkeys})

        let data = await this.getdata();
        console.log(data)
        this.setState({data:data.data });
        this.setState({datafiltered:data.data });
        this.setState({filterStr:""})
        console.log(this.state.data)
      } catch (e) {
        //alert(e);
      }

      this.setState({ isLoading: false });
    }
    getAdmin(data){
      let getdata = {
        'queryStringParameters': data
      }
      return API.get("AltiomData", "/welcome",getdata);
    }

  getdata() {
    return API.get("AltiomData", "/altiom");
  }


  senddata(data) {
    console.log("SEND"+data)
    return

    //API.get("AltiomData", "/parts",{body:data});
  }

  defined(v){
    if(v===undefined)
      return ""
      return v
  }



  altiomList(altiom){
    return altiom.map(
      (p, i) =>

            <AltiomTile {...p._source}></AltiomTile>

    );
  }

  filterList=(event) =>{
    console.log(event)
    let updatedList = this.state.data;
    updatedList = updatedList.filter(function(item){
      return JSON.stringify(item).toLowerCase().search(
        event.target.value.toLowerCase()) !== -1;
    });
    this.setState({datafiltered: updatedList});
  }

  branchname=(key)=>{
    let resp=key
    if( key in this.state.branchdata){
      try{
        console.log(this.state.branchdata[key].name)
        resp=this.state.branchdata[key].name
      }catch(err){}
    }


    return resp
  }

  data_sort=(a,b)=>{

    let sA=a[this.state.sortmode]
    let sB=b[this.state.sortmode]
    if(this.state.sortmode=="_id"){
      sA=a["_id"]
      sB=b["_id"]
    }
    else{
      sA=a["_source"][this.state.sortmode]
      sB=b["_source"][this.state.sortmode]
    }


    if(sA<sB){
      if(this.state.sortmodereverse==true)
        return 1
      return -1
    }
    if(sA>sB){
      if(this.state.sortmodereverse==true)
        return -1
      return 1
    }
    return 0
  }

  changeSort=(key)=>{
    console.log(key)
    if(key==this.state.sortmode){
      console.log(this.state.sortmodereverse)
      this.setState({sortmodereverse:!this.state.sortmodereverse})
    }
    this.setState({sortmode:key})
  }


  hightlightSort(d){

    if(d==this.state.sortmode){
      return "bolder"
    }
    return ""


  }



  renderAltioms(altiom){
    return (<div>
      <h1>Altiom List</h1>




      <div className="filter-list">
     <input type="text" placeholder="Search" value={this.filterStr} onChange={this.filterList}/>
      {this.altiomList(altiom)}
      </div>
      <Table striped bordered condensed hover>

      <thead>
        <tr>
          <th className={this.hightlightSort("_id")}>ID <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('_id')}></i></th>
          <th className={this.hightlightSort("ROOM")}>ROOM <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('ROOM')}></i></th>
          <th className={this.hightlightSort("branch")}>BRANCH <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('branch')}></i></th>
          <th className={this.hightlightSort("last_seen")}>LAST SEEN <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('last_seen')}></i></th>
          <th className={this.hightlightSort("VERSION")}>VERSION <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('VERSION')}></i></th>
        </tr>
      </thead>

      {altiom.sort((a,b)=>this.data_sort(a,b,this.state.sortmode)).map( (p,i)=>
        <tr>
          <td><a href={"/a/"+p._id}>{p._id}</a></td>
          <td>{p._source.ROOM}</td>
          <td>{this.branchname(p._source.branch)}</td>
          <td>{moment(p._source.last_seen).format('YYYY-MM-DD hh:mm')}</td>
          <td>{p._source.VERSION}</td>
          </tr>
      )}
      </Table>
      </div>)


  }


  renderLander() {
    return (
      <div className="lander">
        <h1>ALTIOM</h1>
        <p>Online Interface</p>
      </div>
    );
  }


  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderAltioms(this.state.datafiltered) : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AllAltioms.js